import React from 'react';
import Component from '@vfuk/core-field-wrapper';
const FieldWrapper = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default FieldWrapper;
